import { getRouteTree } from '@app/constants'
import { useCurrentRoute } from '@app/lib/hooks'
import { PropsWithChildren } from 'react'

export const RoutePermissionCheck = ({ children }: PropsWithChildren<any>) => {
	const { route } = useCurrentRoute()

	if (route) {
		getRouteTree(route)
	}

	return <>{children}</>
}
